module.exports = __webpack_public_path__ + "img/Group 6830@2x.2dc45dc6.png";